document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      // Modify default options, then return them
      const { html, item, components } = templateOptions;

      function formatPriceElements(priceStr) {
        const separator = priceStr.includes(' - ') ? ' - ' : ' to ';
        const priceParts = priceStr.split(separator);
        const isRange = priceParts.length > 1;
        return priceParts.map(price => {
          const numericValue = parseFloat(price.replace(/[^0-9.]/g, ''));
          let processedPrice = numericValue < 10000 ? price.replace(/,/g, '') : price;
          processedPrice = processedPrice.replace(/\$/g, '<span class="sc-dollar-subs">$</span>');
          processedPrice = processedPrice.replace(/\.(\d{2})/g, function(match, decimals) {
            return decimals === '00' ? '' : '<span class="sc-decimal-subs">' + decimals + '</span>';
          });
          return processedPrice;
        }).join(isRange ? separator : '');
      }

      return html`
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem"
      onClick="${() => trackSearchAttribution(item)}"
    >
      <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img
            src="${item.product_image}"
            alt="${item.title}"
          />
        </div>
        <div class="aa-ItemContentBody">
          <div class="aa-ItemContentBrand">
            ${
              item.product_type &&
              components.Highlight({ hit: item, attribute: "product_type" })
            }
           removing vendor
          </div>
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: "title" })}
              <span class="algolia-variant">
                ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
              </span>
            </div>
          </div>
          <div class="aa-ItemContentPrice">
            <div class="aa-ItemContentPriceCurrent">
              ${html([formatPriceElements(algoliaShopify.helpers.displayPrice(item, distinct))])}
            </div>
          </div>
        </div>
      </div>
    </a>
  `;
    }
  );


  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components, trackSearchAttribution) {
    const hitImage = algoliaShopify.helpers.renderImage(hit, 250);

    function formatPriceElements(priceStr) {
      const separator = priceStr.includes(' - ') ? ' - ' : ' to ';
      const priceParts = priceStr.split(separator);
      const isRange = priceParts.length > 1;
      return priceParts.map(price => {
        const numericValue = parseFloat(price.replace(/[^0-9.]/g, ''));
        let processedPrice = numericValue < 10000 ? price.replace(/,/g, '') : price;
        processedPrice = processedPrice.replace(/\$/g, '<span class="sc-dollar-subs">$</span>');
        processedPrice = processedPrice.replace(/\.(\d{2})/g, function(match, decimals) {
          return decimals === '00' ? '' : '<span class="sc-decimal-subs">' + decimals + '</span>';
        });
        return processedPrice;
      }).join(isRange ? separator : '');
    }

    return html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="${() => trackSearchAttribution(hit)}"
      >
      <a href="${algoliaShopify.helpers.instantsearchLink(hit)}">
		  <img class="ais-hit--picture" src="${hit.product_image}" alt="${hit.title}"/>
	  </a>

        <div class="ais-hit--details">
          <p class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              title="${algoliaShopify.helpers.fullTitle(
                hit.title,
                hit._distinct,
                hit.variant_title
              )}"
            >
              ${components.Highlight({ attribute: 'title', hit })}
              ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
            </a>
          </p>
          <p
            class="ais-hit--subtitle"
            title="${hit.product_type}${algoliaShopify.translation_helpers.by(
              hit.vendor
            )}"
          >
            ${components.Highlight({ attribute: 'product_type', hit })}
            ${hit.vendor &&
              html`
                <span> ${algoliaShopify.translations.by} </span>
              `}
            ${hit.vendor && components.Highlight({ attribute: 'vendor', hit })}
          </p>
          <p class="ais-hit--price">
            <b>${html([formatPriceElements(algoliaShopify.helpers.displayPrice(hit, hit._distinct))])}</b>
            ${!hit._distinct &&
              html`
                <span class="ais-hit--price-striked"
                  ><span
                    >${algoliaShopify.helpers.displayStrikedPrice(
                      hit.price,
                      hit.compare_at_price
                    )}</span
                  ></span
                >
              `}
            ${!hit._distinct &&
              html`
                <span class="ais-hit--price-discount"
                  >${algoliaShopify.helpers.displayDiscount(
                    hit.price,
                    hit.compare_at_price,
                    hit.price_ratio
                  )}</span
                >
              `}
          </p>
          <!-- Extra info examples - Remove the display: none to show them -->
          <p class="ais-hit--info" style="display: none">
            ${hit.sku &&
              html`
                <span class="algolia-sku"
                  >${components.Highlight({ attribute: 'sku', hit })}</span
                >
              `}
            ${hit.barcode &&
              html`
                <span class="algolia-barcode"
                  >${components.Highlight({ attribute: 'barcode', hit })}</span
                >
              `}
            ${hit.weight &&
              html`
                <span class="algolia-weight">${hit.weight}</span>
              `}
            ${!hit.taxable &&
              html`
                <span class="algolia-taxable"
                  >${algoliaShopify.translations.taxFree}</span
                >
              `}
          </p>
          <!-- Tags example - Remove the display: none to show them -->
          <p class="ais-hit--tags" style="display: none">
            ${hit?._highlightResult.tags?.map(
              tag =>
                html`
                  <span class="ais-hit--tag">${tag.value}</span>
                `
            )}
          </p>
          ${!hit._distinct &&
            html`
              <form
                id="algolia-add-to-cart-${hit.objectID}"
                style="display: none;"
                action="/cart/add"
                method="post"
                enctype="multipart/form-data"
              >
                <input type="hidden" name="id" value="${hit.objectID}" />
              </form>
              <p class="ais-hit--cart">
                ${hit.can_order
                  ? html`
                      <button
                        class="ais-hit--cart-button"
                        data-form-id="algolia-add-to-cart-${hit.objectID}"
                      >
                        ${algoliaShopify.translations.addToCart}
                      </button>
                    `
                  : html`
                      <button
                        class="ais-hit--cart-button ais-hit--cart-button__disabled"
                      >
                        ${algoliaShopify.translations.outOfStock}
                      </button>
                    `}
              </p>
            `}
			

        </div>
      </div>
    `;
  });
});

document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    return html`
      <div class="ais-page">
        <!--<h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>-->
		<h1 class="ais-h2">Voltage® Advanced Search</h1>
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">
          ${algoliaShopify.translations.showFilters}
        </div>
        <div class="ais-facets">
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${data.facets.map(
            facet =>
              html`
                <div
                  class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                >
                  <label
                    for="${facet.escapedName}"
                    class="ais-range-slider--header ais-facet--header ais-header"
                    >${facet.title}</label
                  >
                  <input
                    class="ais-dropdown-checkbox"
                    type="checkbox"
                    id="${facet.escapedName}"
                    name="dropdown"
                  />
                  <div
                    class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                  ></div>
                </div>
              `
          )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
                : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  });
});

document.addEventListener('algolia.instantSearch.afterInit', function() {
  const checkboxIds = [
    'vendor',
	'named_tags.alg_application',
	'named_tags.alg_heads',
	'named_tags.alg_volts',
	'named_tags.alg_water_source',
	'named_tags.alg_features',
	'named_tags.alg_type',
	'named_tags.alg_boiler',
	'named_tags.alg_budget',
	'named_tags.alg_steam',
	'named_tags.alg_style',
	'named_tags.alg_shot_capacity',
	'named_tags.alg_beverage_type',
	'named_tags.alg_origin',
	'named_tags.alg_flat_burr_size',
	'named_tags.alg_interface',
	'named_tags.alg_unit_height',
	'named_tags.alg_adjustment',
	'named_tags.alg_hopper_count',
	'named_tags.alg_hopper_capacity',
	'named_tags.alg_burrs',
	'named_tags.alg_dose_capacity',
	'named_tags.alg_noise_level',
	'named_tags.alg_grind_speed',
	'named_tags.alg_RPM'
  ];
  checkboxIds.forEach(id => {
    const checkbox = document.querySelector(`input#${CSS.escape(id)}`);
    if (checkbox) {
      checkbox.checked = true;
    }
  });
});